import { useContextSelector } from "use-context-selector";
import { VideoChatContext } from "../context/VideoChatContext";

export const useVideoChat = () => {
  const permission = useContextSelector(
    VideoChatContext,
    (context) => context.permission
  );
  const handleSetPermission = useContextSelector(
    VideoChatContext,
    (context) => context.handleSetPermission
  );

  return {
    permission,
    handleSetPermission,
  };
};
